import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WrapperComponent } from './components/buildingblocks/wrapper/wrapper.component';
import { LabelComponent } from './components/forms/label/label.component';
import { TableComponent } from './components/table/table.component';
import { FormComponent } from './components/form.component';
import { InputComponent } from './components/input.component';
import { TextareaComponent } from './components/textarea.component';
import { InputgroupComponent } from './components/forms/inputgroup/inputgroup.component';
import { SelectComponent } from './components/select/select.component';
import { ToggleComponent } from './components/forms/toggle/toggle.component';
import { ParagraphComponent } from './components/copy/paragraph/paragraph.component';
import { HeaderComponent } from './components/header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HeadersectionComponent } from './components/headersection/headersection.component';
import { CenterheaderComponent } from './components/copy/centerheader/centerheader.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { TestimonialComponent } from './components/testimonial/testimonial.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ShareModule } from 'ngx-sharebuttons';
import { AnalyticsModule } from '@angular/fire/analytics';
import { AuthModule } from '@angular/fire/auth';
import { FunctionsModule } from '@angular/fire/functions';
import { FirestoreModule } from '@angular/fire/firestore';
import { StorageModule } from '@angular/fire/storage';
import { CardComponent } from './components/buildingblocks/card.component';
import { CheckboxandlinkComponent } from './components/buildingblocks/checkboxandlink/checkboxandlink.component';
import { NotifyComponent } from './components/notify/notify.component';
import { OrderByPipe } from './pipes/orderby_pipe';
import { SidemenuComponent } from './components/sidemenu/sidemenu.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faAd, faAngleDoubleLeft, faBan, faBars, faBell as fasBell, faBroadcastTower, faCalendar, faCalendarAlt, faCalendarCheck, faSlash, faCalendarPlus, faCheck, faCheckDouble, faChevronCircleLeft, faChevronCircleRight, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircle, faClock, faCog, faCogs, faCoins, faComment as fasComment, faCopy, faCreditCard, faEdit as fasEdit, faEnvelope, faExchangeAlt, faExclamationTriangle, faExternalLinkAlt, faFileImport, faFilm, faFilter, faFlag, faFolderOpen, faHeart, faHome, faImages, faInfinity, faList, faLock, faMap, faMapMarkerAlt, faMapPin, faMobile, faPalette, faPen, faPhoneSquare, faPlug, faPlus, faPuzzlePiece, faQuestion, faRoad, faRocket, fas, faSearch, faShieldAlt, faShoppingBag, faSignInAlt, faSignOutAlt, faSms, faStar, faStickyNote as fasStickyNote, faStopwatch, faSwimmer, faTemperatureLow, faThumbsUp, faTicketAlt, faTimes, faTint, faTrash, faUmbrellaBeach, faUpload, faUserAlt, faUserCog, faUserEdit, faUserPlus, faUsers, faUserSlash, faWater, faWind, faWindowMaximize, faUserShield, faCalendarWeek, faFolder, faSun, faRunning, faMinus, faCode, faUser, faTable, faImage, faWifi, faClose, faFirstAid, faMousePointer, faCoffee, faPlane, faRuler, faLink, faLineChart, faSave, faSign, faSignature, faTag, faMinimize, faMaximize, faUsersRectangle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular, faStickyNote as farStickyNote, faBell as farBell, faComment as farComment, faEdit as farEdit } from '@fortawesome/free-regular-svg-icons';
import { faAndroid, faApple, fab, faFacebook, faGoogle, faInstagram, faLinkedin, faNfcSymbol, faPinterest, faTelegram, faTwitter, faWhatsapp, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { LightweightmenuComponent } from './components/lightweightmenu/lightweightmenu.component';
import { StepsComponent } from './components/steps/steps.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { RetryComponent } from './components/retry/retry.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { ConfirmationComponent } from './components/buildingblocks/confirmation/confirmation.component';
import { CardlistitemComponent } from './components/buildingblocks/cardlist/item/cardlistitem.component';
import { CardlistwrapperComponent } from './components/buildingblocks/cardlist/wrapper/cardlistwrapper.component';
import { CardlistnewComponent } from './components/buildingblocks/cardlist/new/cardlistnew.component';
import { ModalComponent } from './components/modal/modal.component';
import { InlineFormComponent } from './components/forms/inlineform/inlineform.component';
import { TableCellComponent } from './components/table/cell.component';
import { SafePipe } from './pipes/safe_pipe';
import { ImageselectComponent } from './components/forms/imageselect/imageselect.component';
import { UploadimageComponent } from './components/uploadimage/uploadimage.component';
import { FilemanagerComponent } from './components/filemanager/filemanager.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { FilemanagerfilesComponent } from './components/filemanagerfiles/filemanagerfiles.component';
import { FilemanagerscrollableshellComponent } from './components/filemanager/components/filemanagerscrollableshell/filemanagerscrollableshell.component';
import { FilemanagerwrapperComponent } from './components/filemanager/components/filemanagerwrapper/filemanagerwrapper.component';
import { SearchresultsComponent } from './components/searchresults/searchresults.component';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { SearchresultsSwimspotsComponent } from './components/searchresults/components/searchresults-swimspots/searchresults-swimspots.component';
import { SearchresultsWrapperComponent } from './components/searchresults/components/searchresults-wrapper.component';
import { SearchresultsResultComponent } from './components/searchresults/components/searchresults-result.component';
import { AnimationComponent } from './components/animation/animation';
import { EmptyComponent } from './components/empty/empty.component';
import { ModalTopperComponent } from './components/modaltopper.component';
import { FormTagsComponent } from './components/formtags.component';
import { FormRatingComponent } from './components/forms/formrating/formrating.component';
import { DatepickerModule } from 'ng2-datepicker';
import { FormdatepickerComponent } from './components/forms/formdatepicker/formdatepicker.component';
import { SwimspotListItemComponent } from './components/swimspotslist/swimspotlistitem.component';
import { SwimspotListWrapperComponent } from './components/swimspotslist/swimspotlistwrapper.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ActionsWrapperComponent } from './components/actions/actionswrapper.component';
import { ActionsListItemComponent } from './components/actions/actionslistitem.component';
import { ToDoWrapperComponent } from './components/todo/todowrapper.component';
import { ToDoListItemComponent } from './components/todo/todolistitem.component';
import { PanelComponent } from './components/panel/panel.component';
import { NgChartsModule } from 'ng2-charts';
import { WildHeaderComponent } from './components/wild_header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NotificationsListComponent } from './components/sidemenu/components/notificationslist.component';
import { PanelRowComponent } from './components/panel/components/panelrow.component';
import { PanelHeaderComponent } from './components/panel/components/panelheader.component';
import { MoneyInputDirective } from './directive/moneyinput.directive';
import { PricePipe } from './pipes/price';
import { BookingProfileFormComponent } from './components/bookingprofile.component';
import { OrderLineActivitysomponent } from './components/orderline_activity';
import { UserProfileDetailsComponent } from './components/userprofiledetails.component';
import { AppDownloadLinksComponent } from './components/appdownloadlinks.component';
import { DetailsSectionComponent } from './components/detailssection.component';
import { InlineFormTightComponent } from './components/forms/inlineformtight/inlineformtight.component';
import { ListItemComponent } from './components/listitem.component';
import { CheckboxComponent } from './components/checkbox.component';
import { ReadMoreSwimSpotComponent } from './components/readmoreswimspot.component';
import { PointOnMapComponent } from './components/pointonmap.component';
import { SearchResultComponent } from './components/searchresult.component';
import { RegistrationPageContainerComponent } from './components/registrationpagecontainer.component';
import { AppPromptComponent } from './services/appprompt/appcompt_component';
import { WildHeroComponent } from './components/wildhero.component';
import { HomePageResultsComponent } from 'src/shared/components/homepageresults.component';
import { SwimSpotSearchComponent } from './components/swimspotsearch.component';
import { ConvertToClickableLinksDirective } from './directive/converttoclickablelinks.directive';
import { RotatingTextComponent } from './components/rotatingtext/rotatingtext.component';
import { BookingProfileFormForLinkedAccountComponent } from './components/bookingprofileforlinkedaccount.component';
import { SearchResultsGridShimmer } from './components/shimmers/searchresultsgrid_shimmer';
import { SearchResultsRowShimmer } from './components/shimmers/searchresultsrow_shimmer';
import { SearchResultShimmer } from './components/shimmers/searchresult_shimmer';
import { WildShareLinksComponent } from './components/wildsharelinks';
import { AddEditNoteComponent } from 'src/wild/modules/business/components/addeditnote.component';
import { NotesComponent } from 'src/wild/modules/business/components/notes.component';
import { RightImageFeatureomponent } from './v2/rightimagefeature/rightimagefeature.component';
import { LeftImageFeatureomponent } from './v2/leftimagefeature/leftimagefeature.component';
import { SimpleHeroComponent } from './v2/simplehero/simplehero.component';
import { FAQsComponent } from './v2/faqs/faqs.component';
import { BigImageFeatureomponent } from './v2/bigimagefeature/bigimagefeature.component';
import { ImageCloudComponent } from './v2/imagecloud/imagecloud.component';
import { AnimatedHeroComponent } from './v2/animatedhero/animatedhero.component';
import { TextAndInfoComponent } from './v2/textandinfo/textandinfo.component';
import { LogoCloudComponent } from './v2/logocloud/logocloud.component';
import { TitlesComponent } from './v2/shared/titles/titles.component';
import { CTASComponent } from './v2/shared/ctas/ctas.component';
import { TextAndCirclesComponent } from './v2/textandcircles/textandcircles.component';
import { GetTheAppComponent } from './components/gettheapp/gettheapp.component';
import { QRCodeModule } from 'angularx-qrcode';
import { SentMessagesListComponent } from 'src/wild/modules/business/components/messageslist.component';
import { SubscribeModalComponent } from './components/subscribemodal.component';
import { SubscribeComponent } from './components/subscribe.component';
import { SubscribeWelcomeModalComponent } from './components/subscribewelcomemodal.component';
import { ManageSubscriptionModal } from './components/manageSubscriptionModal.component';

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    SafePipe,
    PointOnMapComponent,
    SwimspotListItemComponent,
    MoneyInputDirective,
    ConvertToClickableLinksDirective,
    TextAndCirclesComponent,
    SwimspotListWrapperComponent,
    RotatingTextComponent,
    SearchResultComponent,
    SearchresultsComponent,
    BookingProfileFormComponent,
    RightImageFeatureomponent,
    LeftImageFeatureomponent,
    SimpleHeroComponent,
    AnimatedHeroComponent,
    GetTheAppComponent,
    FAQsComponent,
    BigImageFeatureomponent,
    RetryComponent,
    FilemanagerscrollableshellComponent,
    NotificationsListComponent,
    ImageCloudComponent,
    AppPromptComponent,
    AppDownloadLinksComponent,
    SwimSpotSearchComponent,
    UserProfileDetailsComponent,
    FilemanagerwrapperComponent,
    ConfirmationComponent,
    SearchresultsSwimspotsComponent,
    UploadimageComponent,
    ReadMoreSwimSpotComponent,
    ModalTopperComponent,
    SubscribeComponent,
    SubscribeModalComponent,
    SubscribeWelcomeModalComponent,
    ManageSubscriptionModal,
    CardlistwrapperComponent,
    TextAndInfoComponent,
    LogoCloudComponent,
    PanelHeaderComponent,
    ImageselectComponent,
    ActionsWrapperComponent,
    DetailsSectionComponent,
    OrderLineActivitysomponent,
    ActionsListItemComponent,
    TableCellComponent,
    WildHeaderComponent,
    TableComponent,
    FormComponent,
    InputComponent,
    TextareaComponent,
    ListItemComponent,
    EmptyComponent,
    InputgroupComponent,
    ToDoWrapperComponent,
    ToDoListItemComponent,
    TitlesComponent,
    SelectComponent,
    ToggleComponent,
    HeaderComponent,
    FooterComponent,
    CTASComponent,
    RegistrationPageContainerComponent,
    InlineFormComponent,
    ParagraphComponent,
    LabelComponent,
    TabsComponent,
    HeadersectionComponent,
    WildShareLinksComponent,
    CenterheaderComponent,
    FormTagsComponent,
    GalleryComponent,
    InlineFormTightComponent,
    TestimonialComponent,
    CardlistnewComponent,
    PanelRowComponent,
    LoaderComponent,
    BookingProfileFormForLinkedAccountComponent,
    NotfoundComponent,
    FilemanagerfilesComponent,
    PanelComponent,
    FormRatingComponent,
    FormdatepickerComponent,
    SidemenuComponent,
    HomePageResultsComponent,
    FilemanagerComponent,
    ModalComponent,
    CardlistitemComponent,
    CheckboxComponent,
    SearchresultsWrapperComponent,
    SearchresultsResultComponent,
    NotifyComponent,
    AnimationComponent,
    CardComponent,
    WildHeroComponent,
    CheckboxandlinkComponent,
    OrderByPipe,
    PricePipe,
    SearchResultShimmer,
    SearchResultsRowShimmer,
    SearchResultsGridShimmer,
    StepsComponent,
    LightweightmenuComponent,
    NotesComponent,
    SentMessagesListComponent,
    AddEditNoteComponent,
    WrapperComponent],
  imports: [
    RouterModule,
    HttpClientJsonpModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    CommonModule,
    HttpClientModule,
    ShareModule,
    DatepickerModule,
    AnalyticsModule,
    FirestoreModule,
    AuthModule,
    FunctionsModule,
    QRCodeModule,
    StorageModule,
    FontAwesomeModule,
    LottieModule.forRoot({ player: playerFactory }),
    NgChartsModule

    // BrowserModule, BrowserAnimationsModule, LazyLoadImageModule (if using it), CarouselModule (if using it), InfiniteScrollModule (if using it), HttpModule ( if using it)
  ],
  exports: [
    CommonModule,
    NgChartsModule,
    GoogleMapsModule,
    QRCodeModule,
    RetryComponent,
    HomePageResultsComponent,
    PointOnMapComponent,
    ShareModule,
    TextAndCirclesComponent,
    GetTheAppComponent,
    TextAndInfoComponent,
    SearchResultShimmer,
    SearchResultsRowShimmer,
    SearchResultsGridShimmer,
    SubscribeComponent,
    SubscribeModalComponent,
    SubscribeWelcomeModalComponent,
    ManageSubscriptionModal,
    SearchResultShimmer,
    CTASComponent,
    CardlistitemComponent,
    AppDownloadLinksComponent,
    ConfirmationComponent,
    MoneyInputDirective,
    BookingProfileFormForLinkedAccountComponent,
    ConvertToClickableLinksDirective,
    TabsComponent,
    SwimSpotSearchComponent,
    EmptyComponent,
    FormsModule,
    PanelRowComponent,
    BookingProfileFormComponent,
    ReadMoreSwimSpotComponent,
    FormdatepickerComponent,
    SwimspotListItemComponent,
    RightImageFeatureomponent,
    BigImageFeatureomponent,
    LeftImageFeatureomponent,
    SimpleHeroComponent,
    AnimatedHeroComponent,
    FAQsComponent,
    CheckboxComponent,
    SwimspotListWrapperComponent,
    FormTagsComponent,
    RegistrationPageContainerComponent,
    ListItemComponent,
    PanelComponent,
    LogoCloudComponent,
    RotatingTextComponent,
    TitlesComponent,
    ImageCloudComponent,
    FooterComponent,
    ModalComponent,
    TableComponent,
    ModalTopperComponent,
    InlineFormComponent,
    FormComponent,
    ActionsWrapperComponent,
    DetailsSectionComponent,
    ActionsListItemComponent,
    AnimationComponent,
    InputComponent,
    WildHeroComponent,
    TextareaComponent,
    ToDoWrapperComponent,
    ToDoListItemComponent,
    FilemanagerfilesComponent,
    InputgroupComponent,
    SelectComponent,
    ToggleComponent,
    SearchresultsComponent,
    WildHeaderComponent,
    HeaderComponent,
    ParagraphComponent,
    ImageselectComponent,
    LabelComponent,
    FilemanagerComponent,
    HeadersectionComponent,
    UserProfileDetailsComponent,
    InlineFormTightComponent,
    CardlistwrapperComponent,
    CenterheaderComponent,
    GalleryComponent,
    OrderLineActivitysomponent,
    CardlistnewComponent,
    TestimonialComponent,
    TableCellComponent,
    PricePipe,
    LoaderComponent,
    SearchResultComponent,
    UploadimageComponent,
    PanelHeaderComponent,
    SidemenuComponent,
    ReactiveFormsModule,
    WildShareLinksComponent,
    NotfoundComponent,
    OrderByPipe,
    FormRatingComponent,
    SearchresultsSwimspotsComponent,
    StepsComponent,
    NotifyComponent,
    NotesComponent,
    SentMessagesListComponent,
    AddEditNoteComponent,
    CheckboxandlinkComponent,
    CardComponent,
    SafePipe,
    AnalyticsModule,
    FirestoreModule,
    AuthModule,
    FunctionsModule,
    StorageModule,
    FontAwesomeModule,
    LightweightmenuComponent,
    WrapperComponent,
    LottieModule
  ]
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    // library.addIconPacks(fas, fab, far);
    library.addIcons(
      faHome,
      faSwimmer,
      faWater,
      faTrash,
      faPlus,
      faQuestion,
      faImage,
      faImages,
      faFolderOpen,
      faFilter,
      faPen,
      faUsers,
      faCheckDouble,
      faPalette,
      faCog,
      faTint,
      faBan,
      faUpload,
      faUserCog,
      faExclamationTriangle,
      faFlag,
      faClock,
      faCircle,
      faCoins,
      faFacebook,
      faInstagram,
      faPlane,
      faStopwatch,
      faStar,
      faMapMarkerAlt,
      faShieldAlt,
      faCode,
      faHeart,
      faHeartRegular,
      faUserEdit,
      faCalendarCheck,
      faUser,
      faYoutube,
      faCheck,
      faEnvelope,
      faRuler,
      faUmbrellaBeach,
      faPinterest,
      faLink,
      faCalendar,
      faCalendarAlt,
      faChevronCircleLeft,
      faExchangeAlt,
      faChevronCircleRight,
      faTicketAlt,
      faTable,
      faTag,
      faSignOutAlt,
      faSignature,
      faRoad,
      faChevronLeft,
      faSlash,
      faChevronUp,
      faChevronDown,
      faClock,
      faChevronRight,
      faPhoneSquare,
      faMobile,
      faMinus,
      faWindowMaximize,
      faUserPlus,
      faInfinity,
      faMousePointer,
      faInfinity,
      faWind,
      faTwitter,
      faWhatsapp,
      faMinimize,
      faMaximize,
      faSearch,
      faMap,
      faWater,
      faTemperatureLow,
      faRocket,
      faFileImport,
      farStickyNote,
      faAd,
      faSignInAlt,
      fasStickyNote,
      faTimes,
      faLinkedin,
      faTelegram,
      faMapPin,
      faShoppingBag,
      faThumbsUp,
      fasComment,
      faCalendarWeek,
      faFolder,
      farComment,
      faBars,
      faStopwatch,
      faClose,
      faFirstAid,
      faAndroid,
      faPuzzlePiece,
      faPlug,
      faUserSlash,
      faUserAlt,
      faLineChart,
      faCoins,
      farEdit,
      faSave,
      fasEdit,
      faWifi,
      faAngleDoubleLeft,
      faBroadcastTower,
      farBell,
      faShieldAlt,
      fasBell,
      faCopy,
      faCoffee,
      faFacebook,
      faSun,
      faGoogle,
      faInfinity,
      faApple,
      faCreditCard,
      faUserShield,
      faNfcSymbol,
      faCalendarPlus,
      faLock,
      faUsersRectangle,
      faQuestionCircle,
      faRunning,
      faCircle,
      faList,
      faSms,
      faMobile,
      faExternalLinkAlt);
  }
}
